const Animations: any = {
	showMe: {
		enter: (target: any) => {
			let image = target.querySelector('[data-anim-image]');
			let upContent = target.querySelectorAll('[data-anim-up]');

			let tl = new TimelineMax();
			return tl
				.fromTo(target, 0.6, {y: 20}, {autoAlpha: 1, y: 0, ease: Power3.easeInOut})
				.to(image, 0.6, {scaleX: 0, ease: Power3.easeInOut})
				.addLabel('line', '')
				.staggerTo(upContent, 0.8, {y: 0, autoAlpha: 1, ease: Power3.easeInOut}, 0.15, 0);
		},
		leave: (target: any) => {
			return TweenMax.to(target, 0, {});
		}
	},
	showContent: {
		enter: (target: any) => {
			let x = target.querySelectorAll('[data-anim-show-right]');
			let tl = new TimelineMax();
			return tl.to(target, 0.5, {autoAlpha: 1, y: 0})
				.staggerTo(x, 1, {className: '+=show-me'}, 0.15);


		},
		leave: (target: any) => {
			return TweenMax.to(target, 0, {});
		}
	},
	staggerCard: {
		enter: (target: any) => {
			let images = target.querySelectorAll('[data-anim-image]');
			let x = target.querySelectorAll('[data-anim-up]');
			let tl = new TimelineMax();
			return tl
				.staggerTo(images, 0.6, {scaleX: 0, ease: Power3.easeInOut}, 0.15, 0.4)
				.staggerTo(x, 0.4, {autoAlpha: 1, y: 0, ease: Power3.easeInOut}, 0.015, 0);

		},
		leave: (target: any) => {
			return TweenMax.to(target, 0, {});
		}
	},

	fadeIn: {
		enter: (target: any) => {
			let fadeInElements = target.querySelectorAll('[data-anim-up]');
			return new TimelineMax({})
				.staggerTo(fadeInElements, 0.6, {autoAlpha: 1, y: 0, ease: Power3.easeInOut}, 0.15);
		}
	},

	fadeInLogos: {
		enter: (target: any) => {
			let fadeInElements = target.querySelectorAll('[data-anim-up]');
			return new TimelineMax({})
				.staggerTo(fadeInElements, 0.5, {autoAlpha: 1, y: 0, ease: Power3.easeInOut}, 0.05);
		}
	},

	partnershipGraph: {
		enter: (target: any) => {
			let divs = target.querySelectorAll('div'),
				spans = target.querySelectorAll('span');
			return new TimelineMax({})
				.set(spans, {autoAlpha: 0, y: 10})
				.staggerTo(divs, 1, {scaleX: 1, ease: Power3.easeInOut}, 0.15)
				.staggerTo(spans, 0.8, {autoAlpha: 1, y: 0, ease: Power3.easeInOut}, 0.15, 0.3);
		}
	},

	fillWorldMap: {
		enter: (target: any) => {
			let filledCountrys = target.querySelectorAll('#filledCountrys path');

			let sortedArr = Array.prototype
				.slice.call(filledCountrys)
				.sort(function (a, b) {
					return +parseInt(a.getAttribute('data-name'), 10) - +parseInt(b.getAttribute('data-name'), 10);
				});

			return new TimelineMax()
				.to(target, 0.5, {autoAlpha: 1})
				.staggerTo(sortedArr, 0.5, {fill: '#006173'}, 0.05);
		}
	},

	worldMap: {
		enter: (target: any) => {
			let svgPaths = target.querySelectorAll('.world__map-paths path'),
				svgPoints = target.querySelectorAll('.world__map-points path');
			return new TimelineMax()
				.set(svgPaths, {drawSVG: '0% 0%', immediateRender: false})
				.to(target, 0.8, {autoAlpha: 1, ease: Power3.easeInOut})
				.staggerFromTo(svgPoints, 0.7, {autoAlpha: 0, y: 5}, {autoAlpha: 1, y: 0, ease: Power3.easeInOut}, 0.12)
				.addCallback(() => {

					new TimelineMax({repeat: -1})
						.fromTo(svgPaths, 2, {drawSVG: '0%'}, {
							drawSVG: "60%",
							ease: Power0.easeNone,
							immediateRender: false
						})
						.fromTo(svgPaths, 2, {drawSVG: "60%"}, {
							drawSVG: "100% 40%",
							ease: Power0.easeNone,
							immediateRender: false
						})
						.fromTo(svgPaths, 2, {drawSVG: "100% 40%"}, {
							drawSVG: "100% 100%",
							ease: Power0.easeNone,
							immediateRender: false
						})
				}, '-=0.5');

		}
	},

	arrowScroll: {
		enter: (target: any) => {
			return new TimelineMax({repeat: -1})
				.to(target, 1, {})
		}
	},

	statsGraph: {
		enter: (target: any) => {
			let graph = target.querySelector('#graph');

			let years = graph.querySelectorAll('#years path');

			/* console.log(years); */

			let loosersEndGraphs = graph.querySelectorAll('g[id^="l"]  path[id^="end"]');
			let loosersStartGraphs = graph.querySelectorAll('g[id^="l"] path[id^="start"]');
			let loosersTextGraphs = graph.querySelectorAll('g[id^="l"]  path[id^="text"]');

			let obratEndGraphs = graph.querySelectorAll('g[id^="o"]  path[id^="end"]');
			let obratStartGraphs = graph.querySelectorAll('g[id^="o"] path[id^="start"]');
			let obratTextGraphs = graph.querySelectorAll('g[id^="o"] path[id^="text"]');

			let tl = new TimelineMax()

			let prepareTimeline = new TimelineMax();
			let obratTimeline = new TimelineMax();

			Array.prototype.forEach.call(loosersStartGraphs, (loosersStartGraph: any, index: number) => {
				prepareTimeline
					.addLabel('graph')
					.fromTo(loosersStartGraph, 0.5, {opacity: 0}, {
						opacity: 1, morphSVG: loosersEndGraphs[index], onComplete: () => {
							if(loosersTextGraphs[index]) {
								TweenMax.fromTo(loosersTextGraphs[index], 0.3, {y: 10, opacity: 0}, {opacity: 1, y: 0});
							}
						}
					}, 0.2 * index);
			});
			Array.prototype.forEach.call(obratStartGraphs, (obratStartGraph: any, index: number) => {
				obratTimeline
					.addLabel('graph1')
					.fromTo(obratStartGraph, 0.5, {opacity: 0}, {
						opacity: 1, morphSVG: obratEndGraphs[index], onComplete: () => {
							if(obratTextGraphs[index]) {
								TweenMax.fromTo(obratTextGraphs[index], 0.3, {y: 10, opacity: 0}, {
									opacity: 1,
									y: 0
								});
							}
						}
					}, 0.2 * index);
			});


			return tl
				.to(target, 0.5, {autoAlpha: 1, ease: Power3.easeInOut})
				.staggerFromTo(Array.from(years).reverse(), 0.4, {opacity: 0, y: 10}, {opacity: 1, y: -10}, 0.15, 0.4)
				.add(prepareTimeline, 0.5)
				.add(obratTimeline, 0.5);

		}
	},
	side: {
		enter: (target: any) => {

			return new TimelineMax()
				.from(target, 0.5, {autoAlpha: 0, ease: Power3.easeInOut})
				.from(target, 0.5,);
		}
	},

	turnoverGraph: {
		enter: (target: any) => {
			// @ts-ignore
			const divs = Array.from(target.querySelectorAll('.bar')).reverse();
			// @ts-ignore
			const spans = Array.from(target.querySelectorAll('.year')).reverse();
			return new TimelineMax({})
				.set(spans, {autoAlpha: 0, y: 10})
				.staggerTo(divs, 1, {scaleY: 1, ease: Power3.easeInOut}, 0.15)
				.staggerTo(spans, 0.8, {autoAlpha: 1, y: 0, ease: Power3.easeInOut}, 0.15, 0.3);
		}
	},

};
